import type { AppLink } from 'types/AppLink';

import * as urls from './urls';

export const ABOUT_LINKS: AppLink[] = [
  {
    text: 'About Hurtigruten Group',
    href: urls.getAboutUsUrl(),
  },
  {
    text: 'Our Brands',
    href: urls.getOurBrandsUrl(),
  },
  {
    text: 'Our History',
    href: urls.getHistoryUrl(),
  },
  {
    text: 'Work With Us',
    href: urls.getPeopleUrl(),
  },
  {
    text: 'Hurtigruten Foundation',
    href: urls.getFoundationUrl(),
  },
];

export const STAY_UPDATED_LINKS: AppLink[] = [
  {
    text: 'Press and Media',
    href: urls.getPressAndMediaUrl(),
  },
  {
    text: 'Sustainability',
    href: urls.getSustainabilityUrl(),
  },
  {
    text: 'Investor Relations',
    href: urls.getInvestorsUrl(),
  },
];
